import React from 'react';
import { CardElement } from 'react-stripe-elements';
import { translate  } from 'react-i18next';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';

class CardSection extends React.Component {
  render() {
    const { t } = this.props;
    
    return (
	    <Row>
      	<Col xs="12">
          <div>{t('Card Details')}</div>
          <FormGroup>

            <CardElement 
              className="form-control" 
              hidePostalCode
              style={{
                base: {
                  fontSize: '18px'
                }
              }} 
            />

          </FormGroup>
        </Col>
      </Row>
    );
  }
};

export default translate ()(CardSection);


// WEBPACK FOOTER //
// ./src/App/Checkout/CardSection.js